import { msg } from '@lingui/core/macro';

import { CREDIT_NOTE_STATUS } from '@/modules/credit-note/public';
import { defineFilters } from '@/shared/filters/define-filters';
import { decimalToCents, parseMoneyInput } from '@/shared/format/money';

// Os 7 filtros do modo excluídos (inventário §4; DeletedCreditListContainer.tsx:113-138,
// services/creditNote/options/index.ts:52-60). Arquivo leve: entra no `validateSearch` da rota.

/**
 * "Data de pagamento" é `type: 'date'` no `FilterProvider` desta tela, sem `dateRangeName`: a data final
 * aparece no formulário e não vai ao fio (filterContext.tsx:112-117). Fiel ao legado, como a U20-1.
 */
export const DELETED_SENDS_FINAL_PAYMENT_DATE = false;

/** `CurrencyFormField` grava centavos (helpers/formats/Currency.ts; CreditNoteFilter.tsx:373-392). */
export function moneyFilterParam(value: string): number | undefined {
  const decimal = parseMoneyInput(value);
  return decimal === null ? undefined : decimalToCents(decimal);
}

/** Número da operação: o `#` é enfeite do campo, fora do valor (CreditNoteFilter.tsx:288-317). */
export function creditNoteNoParam(value: string): string | undefined {
  const digits = value.replace(/\D/g, '');
  return digits === '' ? undefined : digits;
}

/** Data do tipo `date`: `new Date(dia).toISOString()` do dia escolhido, meia-noite de São Paulo (filterContext.tsx:131-134). */
export function dayStartIsoParam(day: string): string {
  return new Date(`${day}T00:00:00-03:00`).toISOString();
}

/** Na ordem alfabética do "Filtrar por" do legado (CreditNoteFilter.tsx:67-75); Data de início e Status fixados. */
export const creditNoteDeletedFilters = defineFilters([
  { key: 'initialDate', to: 'finalDate', type: 'dateRange', label: msg`Data de início`, fromLabel: msg`Filtrar por data inicial`, toLabel: msg`Filtrar por data final`, pinned: true },
  {
    key: 'initialPaymentDate',
    to: 'finalPaymentDate',
    type: 'dateRange',
    label: msg`Data de pagamento`,
    fromLabel: msg`Data inicial do pagamento`,
    toLabel: msg`Data final do pagamento`,
    fromParam: dayStartIsoParam,
    sendTo: DELETED_SENDS_FINAL_PAYMENT_DATE,
  },
  { key: 'creditNoteNo', type: 'text', label: msg`Número da operação`, placeholder: msg`#48213`, max: 12, toParam: creditNoteNoParam },
  { key: 'status', type: 'status', label: msg`Status`, options: CREDIT_NOTE_STATUS, pinned: true },
  { key: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Filtrar por todos` },
  { key: 'maxValue', type: 'text', label: msg`Valor máximo`, placeholder: msg`Em reais, como 50.000,00`, max: 20, toParam: moneyFilterParam },
  { key: 'minValue', type: 'text', label: msg`Valor mínimo`, placeholder: msg`Em reais, como 1.000,00`, max: 20, toParam: moneyFilterParam },
]);
